// Cancelled (101): a request the office denied, or a cancelled work order.
// Same red as the customer apps' Cancelled pill.
function CancelledStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#FDE5E5] font-OpenSansSemiBold font-[600] text-[#B91C1C] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Cancelled
    </div>
  );
}

export default CancelledStatus;
